export default __webpack_public_path__ + "a3319ed6326f59eb9f066c99fe50acac05a4327fbd7475b653c07b112dc0f248.png";